// Reusable collapsible "How this page works" panel, shown at the bottom of every Work-time
// page. Lists each button/control and what it does so admins can spot & report bugs.
import React, { useState } from 'react';

export interface HelpItem { label: string; desc: string; }

export default function HelpPanel({ items, title = 'How this page works' }: { items: HelpItem[]; title?: string }) {
  const [open, setOpen] = useState(false);
  return (
    <div className="mt-10 border-t border-gray-800 pt-3">
      <button onClick={() => setOpen(o => !o)}
        className="flex items-center gap-2 text-xs text-gray-500 hover:text-gray-300 transition-colors">
        <span className="inline-block w-3">{open ? '▾' : '▸'}</span>
        {title}
        <span className="text-gray-700">— what every control does</span>
      </button>
      {open && (
        <div className="mt-3 bg-[#1a1d27] border border-gray-800 rounded-xl p-4 space-y-2.5">
          {items.map((it, i) => (
            <div key={i} className="flex flex-col sm:flex-row sm:gap-4">
              <span className="text-gray-200 font-medium text-xs sm:min-w-[190px] sm:flex-shrink-0">{it.label}</span>
              <span className="text-gray-500 text-xs">{it.desc}</span>
            </div>
          ))}
          <p className="text-gray-600 text-[11px] pt-2 border-t border-gray-800/60">
            Notice something behaving differently than described here? That's likely a bug — please report it.
          </p>
        </div>
      )}
    </div>
  );
}
